<template>
  <v-app>
    <template v-if="$route.name != null">
      <component :is="currentView">
        <router-view></router-view>
      </component>
    </template>
    <div v-else style="height: 100vh"></div>
  </v-app>
</template>

<script>
import Layout from "@/views/layouts/Layout";
import LoginLayout from "@/views/layouts/LoginLayout";
import EmptyLayout from "@/views/layouts/EmptyLayout";
export default {
  name: "App",
  components: {
    Layout,
    LoginLayout,
    EmptyLayout,
  },
  computed: {
    currentView() {
      // console.log(this.$route.name);
      switch (this.$route.name) {
        case "Login":
          return "LoginLayout";
        case "Invoice":
        case "404":
          return "EmptyLayout";
        default:
          return "Layout";
      }
    },
  },
  data: () => ({
    //
  }),
};
</script>

<style>
.swal2-container {
  font-family: "Roboto", sans-serif;
}
</style>
